import { Tab, Tabs } from 'vant'
import { mapState } from 'vuex'
export default {
  name: 'HtMore',
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    MescrollVue: () => import('mescroll.js/mescroll.vue'),
  },
  data() {
    return {
      items: ['introduce', 'services'],
      isMore: false,
      activeName: '1'
    }
  },
  computed: mapState({
    /**
     * 酒店详情数据模型
     */
    data_: (state) => state.ht.orderDetails
  }),
  methods: {
    onClick(name) {
      this.$nextTick(() => {
        if (name == 0) {
          this.$refs.introduce.scrollIntoView()
        }
        if (name == 1) {
          this.$refs.services.scrollIntoView()
        }
				
      })
    }
  },
}